// extracted by mini-css-extract-plugin
export default {"status":"absenceArchive_status__w6YPM"};